export function defaultSubscriptionNameFromAssignment(input: {
  name?: string | null;
  operationType?: string | null;
  executionDefinitionKey?: string | null;
  safeInputJson?: string | null;
}): string {
  const fromJson = readAssignmentInputName(input.safeInputJson);
  const base = fromJson
    || input.name?.trim()
    || input.operationType?.trim()
    || input.executionDefinitionKey?.trim()
    || 'assignment';
  return `${base} subscription`;
}

function readAssignmentInputName(json?: string | null): string | null {
  if (!json?.trim()) {
    return null;
  }
  try {
    const parsed = JSON.parse(json) as unknown;
    if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) {
      return null;
    }
    const value = (parsed as Record<string, unknown>)['Name'] ?? (parsed as Record<string, unknown>)['name'];
    return typeof value === 'string' && value.trim() ? value.trim() : null;
  } catch {
    return null;
  }
}
